import { Component } from '@angular/core';

@Component({
  selector: 'app-forgot-password-left',
  templateUrl: './forgot-password-left.component.html',
  styleUrls: ['./forgot-password-left.component.scss']
})
export class ForgotPasswordLeftComponent {
  constructor() {}
}
